<template>
  <div class="bl-input-component flex-shrink-0" :data-id="input.id">
    <input
      type="text"
      class="bl-input"
      :id="`bl-input-${id}`"
      :data-id="input.id"
      :placeholder="input.placeholder"
      v-model="value"
    />
    <div class="bl-input-border"></div>
    <BlIcon
      class="bl-input-icon"
      :clickable="true"
      :icon="!!value ? 'close' : 'search'"
      @clicked="value = ''"
      :data-id="input.id"
    />
  </div>
</template>

<script>
import BlIcon from "./BlIcon.vue";

export default {
  name: "BlInputSearch",
  components: { BlIcon },
  props: {
    input: {
      placeholder: {
        type: String,
        required: false
      },
      disabled: {
        type: Boolean,
        required: false
      },
      model: {
        type: String,
        required: true
      },
      id: {
        type: String,
        required: false
      }
    }
  },
  data() {
    return {
      value: ""
    };
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-${combination}`;
    }
  },
  watch: {
    value(val) {
      if (!this.input.disabled) {
        this.$emit("changed", {
          input: this.input,
          value: val
        });
      }
    },
    input: {
      deep: true,
      handler(val) {
        if (val.model !== this.value) this.value = val.model || "";
      }
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.input.model) this.value = this.input.model;
    }, 1);
  }
};
</script>

<style scoped lang="scss">
.bl-input-component {
  position: relative;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  .bl-input {
    position: relative;
    width: 100%;
    height: 2.5rem;
    padding: 0 1rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: calc(11 / 7);
    letter-spacing: 0.5px;
    box-sizing: border-box;
    border-radius: 5px;
    &:focus {
      outline: none;
      & + .bl-input-border {
        border-color: var(--primary-color);
      }
    }
  }
  .bl-input-border {
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 2.5rem;
    border-radius: 5px;
    box-sizing: border-box;
    border: 1px solid var(--border-color);
  }
  .bl-input-icon {
    position: absolute;
    top: 0.5rem;
    right: 1rem;
    width: 1.5rem;
    height: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputSearch.vue